import { useGLTF } from '@react-three/drei';
import { CuboidCollider, RigidBody } from '@react-three/rapier';
import { useRef } from 'react';

import battery from '@/assets/models/battery.glb';
import Animator from '@/components/game/3d/animation/Animator';

const BatteryComposed = ({ index }) => {
	const { nodes } = useGLTF(battery); // , materials
	const scale = 0.07;

	const meshRef = useRef<any>(null);

	const animationParam = {
		position_x_offset: index * 1.5,
		position_y_start: -3,
		position_y_final: 0,
	};

	const batteryMesh = () => {
		return (
			<RigidBody type="fixed" colliders={false}>
				<CuboidCollider
					position={[index * 1.5, 0, 0]}
					args={[1, 0.5, 1]}
				/>
				<mesh
					ref={meshRef}
					castShadow
					receiveShadow
					geometry={(nodes.Battery as any).geometry}
					rotation={[0, Math.PI / 2, 0]}
					scale={scale}
				>
					<meshStandardMaterial color="black" transparent />
				</mesh>
			</RigidBody>
		);
	};

	return (
		<group dispose={null}>
			<Animator
				customMesh={batteryMesh()}
				meshRef={meshRef}
				animationParam={animationParam}
			/>
		</group>
	);
};

useGLTF.preload(battery);

export default BatteryComposed;
